import * as React from 'react';
import { DocLayout } from 'src/layouts/DocLayout';
import { Layout } from 'antd';
import { TransferApiDoc } from 'src/containers/TransferApiDoc';

export class TransferApiDocPage extends React.Component {
  render() {
    return (
      <DocLayout>
        <Layout className="doc-root">
            <TransferApiDoc/>
        </Layout>
      </DocLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/TransferApiDocPage/index.tsx